import { Box } from "@chakra-ui/react";
import BranchServices from "../../components/branches/reports/BranchServices";
import {
  ARRIVAL_RATES_FREQUENCIES,
} from "../../store/constants";
import { useSelector } from "react-redux";
import { getReportDescription } from "../../store/helpers";
import _ from "lodash";
import * as defaultSelectors from "../../store/selectors/defaultSelector";
import {
  ARRIVAL_RATES_PER_SERVICE_COLUMN_DEFINITIONS,
  getRenderConfigSummaryItems,
} from "../../store/renderConfig";

const ArrivalRatesPerService = ({
  
  reportIndex = "**REPORT_INDEX**",
}) => {
  const reportRange = useSelector(defaultSelectors.selectReportRange);
  const reportsData = useSelector(defaultSelectors.selectReportsData);
  const renderConfig = useSelector(defaultSelectors.selectRenderConfig);
  let { data } = reportsData;

  const title = `${reportIndex || ""}. Arrival Rates Per Service`;
  const presentationSummaryItems = getRenderConfigSummaryItems(renderConfig, {
    columnDefinitions: ARRIVAL_RATES_PER_SERVICE_COLUMN_DEFINITIONS,
  });

  //requires array of objects
    if (!_.isArray(data)) {
      data = [data];
    }  

  return (
    <Box className="arrivalRatesPerServiceReport">
      <h1>{title}</h1>
        <p>
          {getReportDescription(reportRange).BranchesArrivalRatesPerService}
        </p>
        {presentationSummaryItems.length ? (
          <div className="reportPresentationSummary">
            <strong>PRESENTATION</strong> {presentationSummaryItems.join(" / ")}
          </div>
        ) : null}
        {!_.isEmpty(data) ? (
          <>
            <BranchServices
              frequency={ARRIVAL_RATES_FREQUENCIES.DAY}
              reportIndex={reportIndex}
              data={data}
            />
          </>
        ) : (
          <Box mt={10}>
            <p>No data available in this report</p>
          </Box>
        )}
    </Box>
  );
};

export default ArrivalRatesPerService;
